import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { ProgramJSONAModel } from "interfaces/jsona-models/ProgramJSONAModel";

export class ProgramSelector extends BaseApiSelector<ProgramJSONAModel> {
  constructor() {
    super(ResourceType.Program);
  }
}
